import React, { useState, useEffect } from "react";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import UsersList from "../components/UsersList";
import { apiFetch } from '../utils/apiClient';

const FormulaireReseauInfo = ({ user }) => {
  const [isSubmitted, setIsSubmitted] = useState(false); // State to control popup
  const [message, setMessage] = useState("");
  const location = useLocation();
  let selectedForm = location.state?.selectedForm;
  const navigate = useNavigate(); // Initialize navigate hook
  const [errors, setErrors] = useState({});
  const [couleur, setcouleur] = useState("");
  const [lieuxTravail, setLieuxTravail] = useState([]);

  // Function to generate numeroFormulaire
  const generateNumeroFormulaire = () => {
    const date = new Date();
    const yy = date.getFullYear().toString().slice(-2); // Get last two digits of the year
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Month (0-padded)
    const dd = String(date.getDate()).padStart(2, "0"); // Day (0-padded)
    const randomNumber = Math.floor(1000 + Math.random() * 9000); // Random 4-digit number

    return `CSV-${yy}${mm}${dd}${randomNumber}-ADACC`;
  };

  const initialFormData = {
    userId: "",
    nom: "",
    numeroFormulaire: generateNumeroFormulaire(),
    courriel: "",
    poste: "",
    nomMembre: selectedForm?.nomMembre ||"",
    prenomMembre: selectedForm?.prenomMembre ||"",
    posteMembre: selectedForm?.posteMembre ||"",
    lieuTravail: selectedForm?.lieuTravail || "",
    dateDebut: selectedForm?.dateDebut || "",
    dateFin: selectedForm?.dateFin || "",
    courrielSuperviseur: selectedForm?.courrielSuperviseur ||"",
    nomSuperviseur: selectedForm?.nomSuperviseur ||"",
    commentairesDemandeur: selectedForm?.commentairesDemandeur || "",
    etatDemande: "En attente",
    traitant: selectedForm?.traitant || [],
    dateSoumission: new Date().toISOString().split("T")[0],
    process:0
  };
  // console.log("selected Form: ", selectedForm);
  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    // console.log(user);
    if (user) {
      setFormData((prevData) => ({
        ...prevData,
        nom: user.displayName,
        userId: user.id,
        courriel: user.mail,
        poste: user.jobTitle,
        // courriel: user.,
      }));
    }

    if (selectedForm) {
      setFormData((prevData) => ({
        ...prevData,
        numeroFormulaire: selectedForm.numeroFormulaire, // Merge selectedForm data into formData
        dateSoumission:
            selectedForm.etatDemande === "Brouillon"
              ? new Date().toISOString().split("T")[0]
              : selectedForm.dateSoumission || prevData.dateSoumission,
      }));
      // console.log(selectedForm._id)
    }
  }, [user, selectedForm]); // Add selectedForm to the dependency array

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/lieux-travail`)
      .then((response) => response.json())
      .then((data) => setLieuxTravail(data))
      .catch((error) => console.error("Erreur :", error));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors("");
  };

  const handleFormAction = async (e, actionType) => {
    e.preventDefault();

    // Set dateSoumission to the current date and time in local timezone
    const currentDate = new Date();

    // Set the etatDemande based on the action type
    const updatedFormData = {
      ...formData,
      etatDemande: actionType,
      dateSoumission: currentDate, // Send as a Date object
    };

    const method = location.state?.selectedForm ? "PUT" : "POST"; // Use PUT if selectedForm exists, otherwise POST
    const formType = "ReseauInfo"; // Define form type
    const url = location.state?.selectedForm
      ? `${process.env.REACT_APP_API_BASE_URL}/form/${location.state.selectedForm._id}?form=${formType}` // Use the selectedForm ID to update
      : `${process.env.REACT_APP_API_BASE_URL}/form?form=${formType}`; // Use POST for creating a new form

    // console.log(updatedFormData);

    // Send the form data to the backend
    try {
      const response = await apiFetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedFormData),
      });

      if (response.ok) {
        setIsSubmitted(true); // Show popup
        // Hide popup after 3 seconds
        await new Promise((resolve) => {
          setTimeout(() => {
            setIsSubmitted(false); // Hide the popup after timeout
            resolve(); // Resolve the promise after 3 seconds
          }, 3000);
        });
        const initialFormData = {
          nom: user.displayName,
          userId: user.id,
          courriel: user.mail,
          poste: user.jobTitle,
          nomMembre: "",
          prenomMembre: "",
          posteMembre: "",
          numeroFormulaire: generateNumeroFormulaire(),
          lieuTravail: "Selectionner un lieu",
          dateDebut: "",
          dateFin: "",
          courrielSuperviseur: "",
          commentairesDemandeur: "",
          etatDemande: "En attente",
          traitant:[], // Add the file property here
          dateSoumission: "",
          process:0
        };

        setFormData(initialFormData);

        navigate("/demande", { state: { selectedForm: null } });

        
      } else {
        console.error(`Failed to ${actionType.toLowerCase()} form data.`);
      }
    } catch (error) {
      console.error(`Error ${actionType.toLowerCase()} form data:`, error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return; // Stop if validation fails
    handleFormAction(e, "En attente");
    setMessage("Succès ! Le formulaire a été soumis.");
    setcouleur("text-green-600");
    // setcouleur("text-green-600")
  };

  const handleSave = (e) => {
    handleFormAction(e, "Brouillon"); // Use "Enregistrer" for save action
    setMessage("Succès ! Le formulaire a été enregistré.\nVeuillez noter que l'enregistrement ne signifie pas que le formulaire a été soumis.");
    setcouleur("text-grey-600");
    setErrors("");
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.nomMembre) {
      newErrors.nomMembre = "Le nom est obligatoire.";
    }
    if (!formData.prenomMembre) {
      newErrors.prenomMembre = "Le prénom est obligatoire.";
    }
    if (!formData.posteMembre) {
      newErrors.posteMembre = "Le poste est obligatoire.";
    }
    if (!formData.lieuTravail.trim()) {
      newErrors.lieuTravail = "Le lieu de travail est obligatoire.";
    }
    if (!formData.dateDebut) {
      newErrors.dateDebut = "La date est obligatoire.";
    }
    if (!formData.dateFin) {
      newErrors.dateFin = "La date est obligatoire.";
    } else if (formData.dateFin <= formData.dateDebut) {
      newErrors.dateFin =
        "La date de fin doit être ultérieure à la date de début.";
    }
    if (
    (!formData.courrielSuperviseur )
  ) {
    newErrors.managerInfo = "Ce champ est requis.";
  }
    // Add other validations if necessary

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const renderError = (field) => {
    return errors[field] ? (
      <p className="flex items-center gap-1.5 text-sm text-red-500 mt-1">
        <span className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-red-100 text-red-500 text-[10px] font-bold flex-shrink-0">
          !
        </span>
        {errors[field]}
      </p>
    ) : null;
  };

  /************************** Handle Inputs *******************************/

  const handleClear = () => {
    // setFormData(initialFormData); // Réinitialise le formulaire à son état initial
    if (user) {
      setFormData((prevData) => ({
        ...prevData,
        nom: user.displayName,
        userId: user.id,
        courriel: user.mail,
        poste: user.jobTitle,
        lieuTravail: "Selectionner un lieu",
        dateDebut: "",
        dateFin: "",
        courrielSuperviseur: "",
        commentairesDemandeur: "",
        etatDemande: "En attente", 
        dateSoumission: "",
      }));
    }
    setErrors("");
  };


  const handleUserSelect = (user) => {
    setFormData((prevData) => ({
      ...prevData,
      courrielSuperviseur: user.mail,
      nomSuperviseur: user.displayName,
    }));
    // console.log(formData);
  };

  return (
    <div className="min-h-screen p-8 bg-white rounded-lg shadow-lg">
      <form
        onSubmit={handleSubmit}
        className=" p-8 bg-gray-100 rounded-lg shadow-lg"
      >
        {/* <h1 className="text-2xl font-bold mb-6 text-black">
          Formulaire de compte informatique temporaire
        </h1> */}
        <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
          <div className="w-[45%]">
          </div>
          <div className="w-1/2  sm:ml-auto">
            <label
              htmlFor="numeroFormulaire"
              className="block text-sm font-medium text-blue-900"
            >
              Numéro de formulaire:
            </label>
            <input
              type="text"
              id="numeroFormulaire"
              name="numeroFormulaire"
              value={formData.numeroFormulaire}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
          </div>
        </div>

        <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
          <div className="w-[45%]">
          </div>
          <div className="w-1/2  sm:ml-auto">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-blue-900"
            >
              Date :
            </label>
            <input
              type="date"
              id="dateSoumission"
              name="dateSoumission"
              value={formData.dateSoumission?.split("T")[0] ?? ""}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
            
          </div>
        </div>

        <div className="w-full flex justify-center mt-6 mb-20">
  <div className="bg-blue-50 border-l-4 border-blue-500 text-blue-800 p-4 rounded-md shadow-md w-fit">
    <p className="text-md font-bold flex items-center gap-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 17v-2a4 4 0 014-4h6m-6 0V9m0 0H9m3 0h3"
        />
      </svg>
      Formulaire de compte informatique temporaire
    </p>
  </div>
</div>

        <div className="bg-white border border-gray-200 rounded-2xl p-6 mb-8 shadow-sm w-full">
  <h2 className="text-xl font-semibold text-blue-900 mb-3">
    Création de comptes temporaires 
  </h2>

  <div className="flex items-center gap-2 text-sm text-gray-600 mb-4">
    <span className="px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-800">
      ⚠️ Exception
    </span>
    <span>Utilisation encadrée</span>
  </div>

  <p className="text-gray-700 leading-relaxed mb-3">
    Ce formulaire constitue un processus d’exception à la gestion standard des comptes utilisateurs, 
    laquelle repose sur les systèmes sources officiels (SAP et Aspen).
  </p>

  <p className="text-gray-700 leading-relaxed mb-3">
    Il est destiné uniquement à la création de comptes temporaires pour des stagiaires.
  </p>

  <p className="text-gray-700 leading-relaxed">
    Il ne doit pas être utilisé pour contourner le processus régulier de création de comptes. 
    Toute demande non conforme pourrait être refusée.
  </p>

  <p className="mt-4 text-gray-800 font-medium">
    — L’équipe TI
  </p>
</div>

<div className="mt-20 w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-blue-400 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5.121 17.804A13.937 13.937 0 0112 15c2.21 0 4.27.534 6.121 1.47M15 10a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
    Information du membre du personnel
  </p>
</div>
        <div className="mt-10 w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
          <div className="w-[45%]">
            <label
              htmlFor="nom"
              className="block text-sm font-medium text-blue-900"
            >
              Nom:
            </label>
            <input
              type="text"
              id="nom"
              name="nom"
              value={formData.nom}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
            
          </div>
        </div>
        <div className="mt-5 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="adresse"
              className="block text-sm font-medium text-blue-900"
            >
              Courriel :
            </label>
            <input
              type="text"
              id="courriel"
              name="courriel"
              value={formData.courriel}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
            
          </div>

          <div className="w-3/5">
            <label
              htmlFor="adresse"
              className="block text-sm font-medium text-blue-900"
            >
              Poste :
            </label>
            <input
              type="text"
              id="poste"
              name="poste"
              value={formData.poste}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
            
          </div>
        </div>

        

        <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="adresse"
              className="block text-sm font-medium text-blue-900"
            >
              Nom du compte temporaire<span className="text-xl text-red-900" >*</span> :
            </label>
            <input
              type="text"
              id="nomMembre"
              name="nomMembre"
              value={formData.nomMembre}
              onChange={handleChange}
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            
              />
            {renderError("nomMembre")}
          </div>

          <div className="w-3/5">
            <label
              htmlFor="prenomMembre"
              className="block text-sm font-medium text-blue-900"
            >
              Prénom du compte temporaire<span className="text-xl text-red-900" >*</span> :
            </label>
            <input
              type="text"
              id="prenomMembre"
              name="prenomMembre"
              value={formData.prenomMembre}
              onChange={handleChange}
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            
              />
            {renderError("prenomMembre")}
          </div>
        </div>
        <div className="mt-5 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="posteMembre"
              className="block text-sm font-medium text-blue-900"
            >
              Poste du compte temporaire<span className="text-xl text-red-900" >*</span> :
            </label>
            <input
              type="text"
              id="posteMembre"
              name="posteMembre"
              value={formData.posteMembre}
              onChange={handleChange}
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            
              />
            {renderError("posteMembre")}
          </div>
        </div>

        <div className="mt-5 w-3/4 grid grid-cols-2 gap-0">
          <div className="w-3/5 ">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-blue-900"
            >
              Lieu de travail<span className="text-xl text-red-900" >*</span> :
            </label>
            <select
              id="lieuTravail"
              name="lieuTravail"
              value={formData.lieuTravail}
              onChange={handleChange}
className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            >
              <option value="">Selectionner un lieu</option>
              {lieuxTravail.map((lieu) => (
                <option key={lieu._id} value={lieu.nom}>
                  {lieu.nom}
                </option>
              ))}
            </select>
            {renderError("lieuTravail")}
          </div>
        </div>

        <div className="mt-5 w-3/4 grid grid-cols-2 gap-0">
          <div className="w-3/5 ">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-blue-900"
            >
              Date de début<span className="text-xl text-red-900" >*</span> :
            </label>
            <input
              type="date"
              id="dateDebut"
              name="dateDebut"
              value={formData.dateDebut}
              onChange={handleChange}
className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
            {renderError("dateDebut")}
          </div>
          <div className="w-3/5 ">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-blue-900"
            >
              Date de fin<span className="text-xl text-red-900" >*</span> :
            </label>
            <input
              type="date"
              id="dateFin"
              name="dateFin"
              value={formData.dateFin}
              onChange={handleChange}
className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
            {renderError("dateFin")}
          </div>
        </div>

        <div className="mt-5 w-3/4 grid grid-cols-2 gap-0">
          <div className="w-3/5 ">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="mb-1 block text-sm font-medium text-blue-900"
            >
              Superviseur<span className="text-xl text-red-900" >*</span> :
            </label>
            { !formData?.courrielSuperviseur && (
            <UsersList onUserSelect={handleUserSelect} initialValue={formData.courrielSuperviseur} isRequired={false}></UsersList>
            )}
            {/* Display the selected user's information */}
                {formData?.courrielSuperviseur && (
                  <div className="mt-4 p-4 rounded-2xl border border-gray-200 shadow-sm bg-white flex items-center gap-4">
                    {/* Avatar */}
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 font-semibold text-lg">
                      {formData?.nomSuperviseur.charAt(0).toUpperCase()}
                    </div>

                    {/* Infos */}
                    <div className="flex flex-col">
                      <span className="text-sm font-semibold text-gray-900">
                        {formData?.nomSuperviseur}
                      </span>
                      <span className="text-sm text-gray-700">
                        {formData?.courrielSuperviseur}
                      </span>
                    </div>

                    {/* Bouton supprimer */}
                      <button
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            nomSuperviseur:"",
                            courrielSuperviseur:""
                          }))
                        }
                        className="ml-auto text-red-400 hover:text-red-500 transition"
                      >
                        ✕
                      </button>
                  </div>
                )}
            {renderError("managerInfo")}
          </div>
        </div>
        <div className="mt-5 w-3/4 grid grid-cols-2 gap-0">
          <div className="w-full ">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-blue-900"
            >
              Commentaires:
            </label>
            <textarea
              placeholder="Ajoutez un commentaire..."
className="mt-1 w-3/5 p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"              rows="2"
              id="commentairesDemandeur"
              name="commentairesDemandeur"
              value={formData.commentairesDemandeur}
              onChange={handleChange}
            ></textarea>
          </div>
        </div>

        <div className="flex justify-start mt-4">
          {/* Left-aligned Buttons */}
          <div className="flex space-x-4">
            {/* Save Button */}
            {/* Reset Button */}
            <button
              type="button"
              onClick={handleClear}
              className="mt-5 w-24 py-2 bg-red-600 hover:bg-red-400 text-white rounded-md"
            >
              Réinitialiser
            </button>
            {(selectedForm?.etatDemande !== "Rejeté") && (
            <button
              type="button"
              onClick={handleSave}
              className="mt-5 w-24 py-2 bg-gray-600 hover:bg-gray-400 text-white rounded-md"
            >
              Enregistrer
            </button>)}

            <button
              type="submit"
              className="mt-5 w-24 py-2 bg-green-600 text-white rounded-md hover:bg-green-400"
            >
              Soumettre
            </button>
          </div>
        </div>
      </form>

      {isSubmitted && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
          <div
            className={`flex items-center space-x-3 px-5 py-4 bg-white ${couleur} rounded-lg shadow-xl transform transition-all duration-500 ease-in-out animate-bounce`}
          >
            <CheckCircleIcon className={`h-8 w-8 ${couleur} animate-pulse`} />
            <span className="text-lg font-semibold">{message}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormulaireReseauInfo;
